import { createSingleEntityStore } from '@core/ngrx-legacy';

import type { CandidateSkillsSummary } from './candidate-skills-summary-http-client';

const { actions, reducer, namespace, selectors } =
  createSingleEntityStore<CandidateSkillsSummary>()('CandidateSkillsSummary', {
    customActions: adapter => ({
      fetch: (state, payload: { candidateId: number }) => adapter.markAsPending(state),
    }),
  });

export {
  actions as CandidateSkillsSummaryActions,
  reducer as CandidateSkillsSummaryReducer,
  selectors as CandidateSkillsSummarySelectors,
  namespace as CandidateSkillsSummaryNamespace,
};
